import { API_ROOT } from '../../config/config'
import { doPost, doGet, doDownload } from './utils'

export const searchFollowHistoryPage = (request) => {
  const url = `${API_ROOT}/v1/legal/follow/history/page/search`
  return doPost(url, request)
}

export const getFollowHistoryList = (litigationId, litigationCode, pageNumber, pageSize) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/legal/follow/history?litigationId=${litigationId}&litigationCode=${litigationCode}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const getFollowById = (followId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/legal/follow/${followId}`
  return doGet(url)
}

export const getDownload = (fileId) => {
  // /api/v1/legal/litigation/attachments/download/{fileId}
  const url = `${API_ROOT}/v1/legal/litigation/attachments/download/${fileId}`
  return doDownload(url)
}
